var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container old-globals"},[_c('cases-data-view-container',{on:{"load":_vm.goToCase,"newCase":function($event){return _vm.newCase()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }